import React from 'react'
import PageWrapper from '../PageWrapper/PageWrapper'
import testimonials from './TestimonialsConfig'
import './TestimonialsPage.css'

const TestimonialsPage = () => {
  return (
    <PageWrapper title='Testimonials'>
      <p className='testimonials-intro'>
        Reviews from Newcastle families about our kids dance classes, teachers and welcoming studio.
      </p>
      {testimonials.map((testimonial, key) =>
        <React.Fragment key={testimonial.name}>
          <div className='testimonial-item'>
            <div className='review'>
              <div className='quotation-mark'>&#8220;</div>
              <div className='review-text'>{testimonial.review}</div>
            </div>
            <div className='testimonial-name'>{testimonial.name}</div>
            
            {key === testimonials.length - 1 ? null :
              <div className='divider'>
                <hr/>
              </div>
            }
          </div>
        </React.Fragment>
      )}
    </PageWrapper>
  )
}

export default TestimonialsPage